import apiResponse from './ApiResponse';
import { ApiService } from './ApiService';

export type Prize = {
  id: number;
  message: string | null;
  link: string | null;
  amount: number | null;
  createdBy: string;
  createdAt: string | null;
};

export class PrizeStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async getPrizes(cohortUserId: number) {
    try {
      const result = await this.api.get(`CohortUser/${cohortUserId}/prizes`);
      return apiResponse.Success<Prize[]>(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
